import React, {Component} from 'react';
import {Modal, ModalHeader} from 'reactstrap';
import {AddBusinessUnitForm} from "./AddBusinessUnitForm";
import { withTranslation } from 'react-i18next';

class AddBusinessUnitModalClass extends Component {
    constructor(props) {
        super(props);
        this.state = {
            modal: false,
        };

        this.toggle = this.toggle.bind(this);
        this.afterSuccessfulSubmit = this.afterSuccessfulSubmit.bind(this);
    }

    toggle() {
        this.setState({
            modal: !this.state.modal
        });
    }

    afterSuccessfulSubmit(newBusinessUnitId) {
        this.toggle();
        this.props.afterSuccessfulSubmit(newBusinessUnitId);
    }

    render() {
        const { t } = this.props;
        return (
            <Modal isOpen={this.state.modal} toggle={this.toggle} className={this.props.className} backdrop="static">
                <ModalHeader toggle={this.toggle}>{t('add_business_unit_modal.title')}</ModalHeader>
                <AddBusinessUnitForm afterSuccessfulSubmit={this.afterSuccessfulSubmit}
                                     clientId={this.props.clientId}
                                     clientName={this.props.clientName}
                                     history={this.props.history}
                />
            </Modal>
        );
    }
}

export const AddBusinessUnitModal = withTranslation()(AddBusinessUnitModalClass);
export default AddBusinessUnitModal;
